import { useNavigate } from "react-router-dom";
import React from "react";
import { CustomSettings } from "../components";

const Cnt_CustomSettings = () => {
  const navigate = useNavigate();

  const onMinimize = () => {
    navigate("");
  };

  return <CustomSettings.Home onMinimize={onMinimize} />;
};

export default Cnt_CustomSettings;
